<template>
  <div class="container">
    <PublicHeader :totalName="$t('safe').SecuritySettings" />
    <div class="lable">{{ $t('safe').Accountsecurity }}</div>
    <div class="content">
      <!-- 手机 -->
      <div class="item">
        <div class="left">
          <span>{{ $t('safe').phone }}</span>
        </div>
        <div v-if="userInfo.phonenumber">
          <span>{{ userInfo.phonenumber | truncateString }}</span>
        </div>
        <div v-else @click="$router.push({ name: 'BindPhone' })">
          <span>{{ $t('safe').Notyetbound }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 邮箱 -->
      <div class="item">
        <div class="left">
          <span>{{ $t('safe').mailbox }}</span>
        </div>
        <div v-if="userInfo.email">
          <span>{{ userInfo.email | truncateString }}</span>
        </div>
        <div v-else @click="$router.push({ name: 'BindEmail' })">
          <span>{{ $t('safe').Notyetbound }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 登录密码 -->
      <div class="item" @click="$router.push({ name: 'UpLoginPwd' })">
        <div class="left">
          <span>{{ $t('safe').Loginpassword }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 资金密码 -->
      <div class="item" @click="$router.push({ name: 'UpPayPwd' })">
        <div class="left">
          <span>{{ $t('safe').Fundcode }}</span>
        </div>
        <div>
          <span>{{ $t('safe').Settings }}</span>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
      <!-- 提币地址管理 -->
      <div class="item" @click="$router.push({ name: 'WalletAddress' })">
        <div class="left">
          <span>{{ $t('safe').Withdrawaladdressmanagement }}</span>
        </div>
        <div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      userInfo: {},
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getMemberInfo()
  },
  methods: {
    // 获取用户信息
    async getMemberInfo() {
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 50px;

  .lable {
    padding: 30px 15px 5px 15px;
    font-size: 14px;
    color: var(--ntext_color);
  }

  .content {
    .item {
      padding: 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        span {
          font-size: 15px;
          color: var(--text_color);
        }
      }

      span {
        font-size: 13px;
        color: var(--ntext_color);
        margin-right: 10px;
      }
    }
  }
}
</style>
